import { Grid, IconButton } from "@mui/material";
import { ImageOutlined, VideocamOutlined, FileCopyOutlined, Close } from "@mui/icons-material";
import {
    Autocomplete, Box, Button, FormField,
    Modal, SingleImageUploader, Typography,
    VideoPlayer,
    useCommonComponentContext,
} from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import Resources from "../../constants/resources";
import AssetService from "../../services/asset/Asset.service";
import CommunityPostService from "../../services/message/CommunityPost.service";

import { useEffect, useMemo, useState } from "react";
import { ICodename, IInput } from "../../commons/interfaces";
import { ICommunityPostDetail } from "../../containers/channel/useChannel";
import { IDataDetail, IDataError, IRecordPost } from "../../containers/post/usePost";



enum ModeInputUpload {
    Node,
    Image,
    Video,
    File,
}

const PopupCreateUpdatePost = (props: {
    open: boolean;
    channelId?: string;
    onClose: () => void;
    listChannels: ICodename[];
    dataDetailPost?: IRecordPost;
    onAction: (isCreate: boolean, data: ICommunityPostDetail) => void;
}) => {

    const Strings = useStrings();

    const {
        language,
        tenantCode,
        serviceCode,
        organizationId,
        onError,
        onSuccess,
        onHideLoading,
        onShowLoading,
    } = useCommonComponentContext();

    const listChannels = useMemo(() => (props.listChannels), [props.listChannels]);

    const [videoUrl, setVideoUrl] = useState<IInput>({});
    const [modeInputUpload, setModeInputUpload] = useState<ModeInputUpload>(0);

    const [errorPost, setErrorPost] = useState<IDataError>({} as IDataError);
    const [dataPost, setDataPost] = useState<IDataDetail>({
        channelId: props.channelId,
        title: { value: { [language]: "" } },
        content: { value: { [language]: "" } },
    } as IDataDetail);


    useEffect(() => {
        if (props.dataDetailPost?.id) {
            setDataPost({
                id: props.dataDetailPost?.id,
                title: props.dataDetailPost?.title,
                content: props.dataDetailPost?.content,
                channelId: props.dataDetailPost?.channelId,
                postImages: props.dataDetailPost?.postImages,
                postVideos: props.dataDetailPost?.postVideos,
            });

            if (!Helpers.isNullOrEmpty(props.dataDetailPost?.postImages?.[0]?.fileId)) {
                setModeInputUpload(ModeInputUpload.Image);
            }
            if (!Helpers.isNullOrEmpty(props.dataDetailPost?.postVideos?.[0]?.fileId)) {
                setModeInputUpload(ModeInputUpload.Video);
            }

        } else {
            setModeInputUpload(0);
            setDataPost({
                channelId: props.channelId,
                title: { value: { [language]: "" } },
                content: { value: { [language]: "" } },
            });
        }

        setVideoUrl(undefined);
        setErrorPost(undefined);
    }, [props.dataDetailPost, props.channelId]);

    const onChangeValuePost = (key: keyof IDataDetail, newValue: any) => {
        setDataPost((prev) => {
            const newData: any = { ...prev };
            if (key === "title" || key === "content") {
                Object.assign(newData, {
                    [key]: {
                        ...prev[key],
                        value: {
                            ...prev[key]?.value,
                            [language]: newValue
                        }
                    }
                })
            } else {
                Object.assign(newData, { [key]: newValue })
            }
            return newData
        });
        setErrorPost((prev) => ({ ...prev, [key]: undefined }));
    }

    const handleSubmit = async () => {
        let isChecked = true;
        let errorTemp: any = { ...errorPost };

        if (Helpers.isNullOrEmpty(dataPost?.channelId)) {
            isChecked = false;
            errorTemp["channelId"] = Strings.Common.REQUIRED;
        }
        if (Helpers.isNullOrEmpty(dataPost?.title?.value?.[language])) {
            isChecked = false;
            errorTemp["title"] = Strings.Common.REQUIRED;
        }
        if (Helpers.isNullOrEmpty(dataPost?.content?.value?.[language])) {
            isChecked = false;
            errorTemp["content"] = Strings.Common.REQUIRED;
        }

        if (!isChecked) {
            setErrorPost(errorTemp);
        } else {
            try {
                onShowLoading();

                let postVideos: any;

                if (dataPost?.postVideos?.length > 0) {
                    const itemVideoUrl = dataPost?.postVideos?.[0];

                    const urlWithId = await AssetService.createUrlAsset({
                        tenantCode: tenantCode,
                        serviceCode: serviceCode,
                        url: [itemVideoUrl?.fileUrl],
                    });

                    postVideos = [
                        {
                            sequence: 0,
                            fileId: urlWithId?.[0]?.id,
                            fileUrl: itemVideoUrl?.fileUrl,
                        }
                    ]
                }

                const newDataSumit: any = {
                    tenantCode: tenantCode,
                    organizationId: organizationId,

                    title: dataPost?.title,
                    content: dataPost?.content,
                    channelId: dataPost?.channelId,
                    postImages: dataPost?.postImages,
                    postVideos: postVideos,
                };

                let result: any;

                if (Helpers.isNullOrEmpty(dataPost?.id)) {
                    result = await CommunityPostService.create(newDataSumit);
                } else {
                    result = await CommunityPostService.update({
                        ...newDataSumit,
                        id: dataPost.id,
                    });
                };

                const resultDetail = await CommunityPostService.getDetail(result?.id);

                props.onAction(Helpers.isNullOrEmpty(dataPost?.id), resultDetail);

                const msg = Helpers.isNullOrEmpty(dataPost?.id)
                    ? Strings.CHANNEL.CREATE_POST_IN_CHANNEL_SUCCESS
                    : Strings.CHANNEL.UPDATE_POST_IN_CHANNEL_SUCCESS;

                onHideLoading();
                onSuccess(msg);

            } catch (error) {
                onHideLoading();
                const err = Helpers.renderExceptionError(error);
                onError(err);
            }
        }

    }

    // 
    const isUrlYoutube = (url: string) => {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
        var match = url.match(regExp);
        if (match && match[2].length === 11) {
            const newurl = 'https://www.youtube.com/embed/' + match[2];
            return { check: true, url: newurl };
        }
        else {
            return { check: true, url: url };
        }
    }

    const handleAddVideoUrl = async () => {
        const newValUrlYoutube = isUrlYoutube(videoUrl?.value);

        if (Helpers.isNullOrEmpty(videoUrl?.value)) {
            setVideoUrl({ ...videoUrl, error: Strings.Common.REQUIRED })
        } else if (!newValUrlYoutube.check) {
            setVideoUrl({ ...videoUrl, error: Strings.CHANNEL.INVALID_URL })
        } else {
            setVideoUrl(undefined);

            onChangeValuePost(
                "postVideos",
                [
                    {
                        sequence: 0,
                        fileUrl: newValUrlYoutube.url,
                    }
                ]
            );
        }
    }

    const inputAddLinkVideo = () => {
        const itemVideoUrl = dataPost?.postVideos?.[0];

        return (
            <Box sx={{ padding: "16px", backgroundColor: "#f2f3f5", border: "1px solid #caccd6", bordeRadius: "4px" }}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="button" color="dark" fontWeight="bold">
                        {Strings.CHANNEL.VIDEO_URL}
                    </Typography>
                    {
                        !Helpers.isNullOrEmpty(itemVideoUrl?.fileUrl) &&
                        <IconButton sx={{ p: 0 }} onClick={() => {
                            setVideoUrl(undefined);
                            setModeInputUpload(ModeInputUpload.Node);

                            onChangeValuePost("postVideos", []);
                        }}>
                            <Close />
                        </IconButton>
                    }
                </Box>

                {Helpers.isNullOrEmpty(itemVideoUrl?.fileUrl)
                    ? (
                        <>
                            <Box my={1}>
                                <FormField
                                    sx={{ mt: 1 }}
                                    variant="outlined"
                                    value={videoUrl?.value}
                                    errorMessage={videoUrl?.error}
                                    placeholder={"https://www.example.com"}
                                    onChangeValue={(url: any) => {
                                        setVideoUrl({ value: url });
                                    }}
                                />
                            </Box>

                            <Typography variant="caption" color="secondary" fontWeight="regular">
                                {Strings.CHANNEL.NOTE_VIDEO_URL}
                            </Typography>

                            <Box mt={1} display="flex" alignItems="center" justifyContent="flex-end">
                                <Button color="secondary" variant="outlined"
                                    onClick={() => {
                                        setVideoUrl(undefined);
                                        setModeInputUpload(ModeInputUpload.Node);
                                    }}
                                >
                                    {Strings.Common.CANCEL}
                                </Button>
                                <Button sx={{ ml: 1 }} color="dark" onClick={() => { handleAddVideoUrl() }}>
                                    {Strings.CHANNEL.ADD_VIDEO}
                                </Button>
                            </Box>
                        </>
                    )
                    : (
                        <Box display="flex" flexDirection="column" justifyContent="center">
                            <Box display="flex" justifyContent="center">
                                {Helpers.isNullOrEmpty(itemVideoUrl?.fileId)
                                    ? (
                                        <img
                                            width={100}
                                            alt="VIDEO_FILES"
                                            src={Resources.VIDEO_FILES}
                                        />)
                                    : (
                                        <VideoPlayer
                                            controls
                                            fileId={itemVideoUrl?.fileId}
                                        />
                                    )
                                }
                            </Box>
                            <Box display="inline-block" textAlign="center">
                                <Typography variant="caption" color="info" fontWeight="regular">
                                    {itemVideoUrl?.fileUrl}
                                </Typography>
                            </Box>
                        </Box>
                    )
                }
            </Box>
        )
    }

    const inputUploadImage = () => {
        const itemImage = dataPost?.postImages?.[0];

        return (
            <Box sx={{ padding: "16px", backgroundColor: "#f2f3f5", border: "1px solid #caccd6", bordeRadius: "4px" }}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="button" color="dark" fontWeight="bold">
                        {Strings.CHANNEL.IMAGE}
                    </Typography>
                    <IconButton onClick={() => {
                        setModeInputUpload(ModeInputUpload.Node);

                        onChangeValuePost("postImages", []);
                    }}>
                        <Close />
                    </IconButton>
                </Box>

                <SingleImageUploader
                    label={""}
                    title={""}
                    description={Strings.CHANNEL.NOTE_IMAGE}

                    key={itemImage?.fileId}
                    fileId={itemImage?.fileId}
                    folderPath={"/channel/temp"}
                    errorMessage={errorPost?.postImages}
                    onChangeImage={(res) => {
                        setErrorPost({ ...errorPost, postImages: res?.error });

                        if (Helpers.isNullOrEmpty(res?.accessUrl) && Helpers.isNullOrEmpty(res?.id)) {
                            setModeInputUpload(ModeInputUpload.Node);
                            onChangeValuePost("postImages", []);
                        } else {
                            onChangeValuePost(
                                "postImages",
                                [
                                    {
                                        sequence: 0,
                                        fileId: res?.id,
                                        fileUrl: res?.accessUrl,
                                    }
                                ]
                            );
                        }
                    }}
                />
            </Box>
        )
    }

    return (
        <>
            <Modal
                fullWidth
                maxWidth="md"
                hasActionButton
                visible={props.open}
                closeButton={Strings.Common.CANCEL}
                buttonAction={props.dataDetailPost?.id ? Strings.Common.SAVE : Strings.CHANNEL.CREATE_POST}
                title={props.dataDetailPost?.id ? Strings.CHANNEL.UPDATE_POST : Strings.CHANNEL.CREATE_NEW_POST}
                onAction={() => { handleSubmit() }}
                onClose={() => { props.onClose() }}
            >
                <Box p={2}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Autocomplete
                                required
                                variant="outlined"
                                data={listChannels || []}
                                defaultValue={dataPost?.channelId}
                                errorMessage={errorPost?.channelId}
                                label={Strings.CHANNEL.POST_IN_CHANNEL}
                                placeholder={Strings.CHANNEL.SELECT_CHANNEL}
                                disabled={!Helpers.isNullOrEmpty(props.channelId)}
                                onChange={(value: any) => {
                                    onChangeValuePost("channelId", value)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormField
                                required
                                maxLength={124}
                                variant="outlined"
                                errorMessage={errorPost?.title}
                                label={Strings.CHANNEL.POST_TITLE}
                                placeholder={Strings.CHANNEL.ENTER_TITLE}
                                value={dataPost?.title?.value?.[language]}
                                onChangeValue={(value: any) => {
                                    onChangeValuePost("title", value)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormField
                                required
                                multiline
                                isFullRow
                                variant="outlined"
                                errorMessage={errorPost?.content}
                                label={Strings.CHANNEL.POST_DESCRIPTION}
                                value={dataPost?.content?.value?.[language]}
                                placeholder={Strings.CHANNEL.ENTER_DESCRIPTION}
                                onChangeValue={(value: any) => {
                                    onChangeValuePost("content", value)
                                }}
                            />
                        </Grid>

                        {
                            (modeInputUpload !== ModeInputUpload.Node) &&
                            <Grid item xs={12}>
                                {
                                    (modeInputUpload === ModeInputUpload.Image) &&
                                    inputUploadImage()
                                }
                                {
                                    (modeInputUpload === ModeInputUpload.Video) &&
                                    inputAddLinkVideo()
                                }
                            </Grid>
                        }

                        {
                            (modeInputUpload === ModeInputUpload.Node) &&
                            <Grid item xs={12}>
                                <Box display="flex" alignItems="center" >
                                    <Button color="secondary" variant="outlined"
                                        onClick={() => { setModeInputUpload(ModeInputUpload.Image) }}>
                                        <ImageOutlined />&nbsp;{Strings.CHANNEL.IMAGE}
                                    </Button>
                                    <Button sx={{ ml: 1 }} color="secondary" variant="outlined"
                                        onClick={() => { setModeInputUpload(ModeInputUpload.Video) }}>
                                        <VideocamOutlined />&nbsp;{Strings.CHANNEL.VIDEO}
                                    </Button>
                                    {/* <Button sx={{ ml: 1 }} color="secondary" variant="outlined"
                                        onClick={() => { }}>
                                        <FileCopyOutlined />&nbsp;{Strings.CHANNEL.FILE}
                                    </Button> */}
                                </Box>
                            </Grid>
                        }
                    </Grid>
                </Box>
            </Modal>
        </>
    );
};

export default PopupCreateUpdatePost;
